import { render, staticRenderFns } from "./MessageThread.vue?vue&type=template&id=471e6a14&scoped=true&"
import script from "./MessageThread.vue?vue&type=script&lang=js&"
export * from "./MessageThread.vue?vue&type=script&lang=js&"
import style0 from "./MessageThread.vue?vue&type=style&index=0&id=471e6a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471e6a14",
  null
  
)

export default component.exports